module.exports = __webpack_public_path__ + "img/cabins--icon--gray.c1658e4e.svg";